export default __webpack_public_path__ + "static/media/fr-asia-15.7ec85179.jpg";